import {
  contactFormUrl,
  requestAirWaybillNumberFormUrl,
  accountApplicationFormUrl,
  updateAccountFormUrl,
  additionalLocationRequestFormUrl,
  emailReferenceFormUrl,
  serviceFailureFormUrl,
  lostOrDamagedClaimFormUrl,
  onlineBookingFormUrl,
  rapidRewardsFormUrl,
  billingAndInvoicingFormUrl
} from '../Main';

const formUrls = {
  "CONTACT_FORM": contactFormUrl,
  "REQUEST_AIR_WAYBILL_NUMBER_FORM": requestAirWaybillNumberFormUrl,
  "ACCOUNT_APPLICATION_FORM": accountApplicationFormUrl,
  "UPDATE_ACCOUNT_FORM": updateAccountFormUrl,
  "ADDITIONAL_LOCATION_REQUEST_FORM": additionalLocationRequestFormUrl,
  "EMAIL_PREFERENCE_FORM": emailReferenceFormUrl,
  "SERVICE_FAILURE_FORM": serviceFailureFormUrl,
  "LOST_OR_DAMAGED_CLAIM_FORM": lostOrDamagedClaimFormUrl,
  "ONLINE_BOOKING_FORM": onlineBookingFormUrl,
  "RAPID_REWARDS_FORM": rapidRewardsFormUrl,
  "BILLING_AND_INVOICING_FORM": billingAndInvoicingFormUrl
};

export default formUrls;



// WEBPACK FOOTER //
// ./src/shared/formUrls.js